"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _ConfigProvider = _interopRequireDefault(require("../../provider/ConfigProvider"));

var _TitledItem = _interopRequireDefault(require("./TitledItem"));

var _Subtitle = _interopRequireDefault(require("./Subtitle"));

var _Block = _interopRequireDefault(require("./Block"));

var _Item = _interopRequireDefault(require("./Item"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var EditView = function EditView(_ref) {
  var config = _ref.config,
      incomplete = _ref.incomplete,
      initiallyOpen = _ref.initiallyOpen,
      onPropertySave = _ref.onPropertySave,
      _ref$bypassDisabled = _ref.bypassDisabled,
      bypassDisabled = _ref$bypassDisabled === void 0 ? false : _ref$bypassDisabled,
      _ref$showLoader = _ref.showLoader,
      showLoader = _ref$showLoader === void 0 ? false : _ref$showLoader,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'create' : _ref$mode;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      isIncomplete = _useContext.isIncomplete,
      getPlainProfile = _useContext.getPlainProfile;

  var handlePropertySave = function handlePropertySave(changedValueName) {
    onPropertySave((0, _defineProperty2.default)({}, changedValueName, context[changedValueName].value), getPlainProfile());
  };

  var handleSave = function handleSave(newProfile) {
    onPropertySave(newProfile || getPlainProfile());
  };

  var valueIsEmpty = function valueIsEmpty(value, item) {
    //Check Location availability
    if (value.valueType === 'LocationType' && value.value.longitude === '0' && value.value.latitude === '0') return true;
    if (item.isEmpty instanceof Function) return item.isEmpty(value.value); // prevent mess made from js not knowing how to boolean

    if (value.valueType === 'Boolean') return false; // zero treatment

    if (value.value === 0) return false;
    if (value.value === null) return false;
    if (!value.value) return true;
    if (Array.isArray(value.value) && value.value.length === 0) return true;
    return false;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [incomplete && isIncomplete() ? incomplete : '', config.edit.map(function (item, i) {
      switch (item.type) {
        /**
         * A subtitle component is used as a dividing headline in the rendered list of editable items
         */
        case 'subtitle':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Subtitle.default, {
            index: i,
            item: item
          }, i);

        /**
         * An item component represents the edit view for a single data item
         */

        case 'item':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Item.default, {
            showLoader: showLoader,
            config: config.componentConfigurations[item.componentConfiguration],
            item: item,
            initiallyOpen: initiallyOpen,
            bypassDisabled: bypassDisabled,
            handlePropertySave: handlePropertySave,
            notEmpty: showLoader ? undefined : !valueIsEmpty(context[config.componentConfigurations[item.componentConfiguration].valueName], item)
          }, i);

        case 'titledItem':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TitledItem.default, {
            mode: mode,
            item: item,
            config: config.componentConfigurations[item.componentConfiguration],
            handlePropertySave: handlePropertySave
          }, i);

        /**
         * A block component is used to change multiple values in one go
         */

        case 'block':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Block.default, {
            config: (0, _extends2.default)({
              // Since this is propagated to the funnel, we need the actual component configurations
              componentConfigurations: config.componentConfigurations
            }, item),
            handleSave: handleSave
          }, i);

        default:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}, i);
      }
    })]
  });
};

var Edit = function Edit(props) {
  var config = props.config,
      profile = props.profile,
      specialDefaults = props.specialDefaults,
      showLoader = props.showLoader;
  return showLoader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(EditView, {
    config: config,
    showLoader: true
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfigProvider.default, {
    config: config,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileProvider.ProfileProvider, {
      baseProfile: profile,
      specialDefaults: specialDefaults,
      stateMode: "volatile",
      dataMode: "edit",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(EditView, (0, _extends2.default)({}, props))
    })
  });
};

var _default = Edit;
exports.default = _default;